import { render } from "./AlternateButton.vue?vue&type=template&id=999931fc&scoped=true&ts=true"
import script from "./AlternateButton.vue?vue&type=script&lang=ts"
export * from "./AlternateButton.vue?vue&type=script&lang=ts"

import "./AlternateButton.vue?vue&type=style&index=0&id=999931fc&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-999931fc"]])

export default __exports__